// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************
//
// Ice version 3.7.0
//
// <auto-generated>
//
// Generated from file `Current.ice'
//
// Warning: do not edit this file.
//
// </auto-generated>
//

/* slice2js browser-bundle-skip */
// (function(module, require, exports)
// {
/* slice2js browser-bundle-skip-end */
/* slice2js browser-bundle-skip */
    const _ModuleRegistry = require("../Ice/ModuleRegistry").Ice._ModuleRegistry;
    const Ice = 
    (
        require("../Ice/Struct"),
        require("../Ice/EnumBase"),
        require("../Ice/Long"),
        require("../Ice/HashMap"),
        require("../Ice/HashUtil"),
        require("../Ice/ArrayUtil"),
        require("../Ice/StreamHelpers"),
        require("../Ice/ObjectAdapterF"),
        require("../Ice/ConnectionF"),
        require("../Ice/Identity"),
        require("../Ice/Version")
    ).Ice;

    const Slice = Ice.Slice;
/* slice2js browser-bundle-skip-end */

    Slice.defineDictionary(Ice, "Context", "ContextHelper", "Ice.StringHelper", "Ice.StringHelper", false, undefined, undefined);

    /**
     * The {@link OperationMode} determines the retry behavior an
     * invocation in case of a (potentially) recoverable error.
     *
     **/
    Ice.OperationMode = Slice.defineEnum([
        ['Normal', 0], ['Nonmutating', 1], ['Idempotent', 2]]);

    /**
     * Information about the current method invocation for servers. Each
     * operation on the server has a <tt>Current</tt> as its implicit final
     * parameter. <tt>Current</tt> is mostly used for Ice services. Most
     * applications ignore this parameter.
     *
     **/
    Ice.Current = class
    {
        constructor(adapter = null, con = null, id = new Ice.Identity(), facet = "", operation = "", mode = Ice.OperationMode.Normal, ctx = null, requestId = 0, encoding = new Ice.EncodingVersion())
        {
            this.adapter = adapter;
            this.con = con;
            this.id = id;
            this.facet = facet;
            this.operation = operation;
            this.mode = mode;
            this.ctx = ctx;
            this.requestId = requestId;
            this.encoding = encoding;
        }
    };

    Slice.defineStruct(Ice.Current, false, true);
/* slice2js browser-bundle-skip */
    exports.Ice = Ice;
/* slice2js browser-bundle-skip-end */
/* slice2js browser-bundle-skip */
// }
// (typeof(global) !== "undefined" && typeof(global.process) !== "undefined" ? module : undefined,
//  typeof(global) !== "undefined" && typeof(global.process) !== "undefined" ? require : this.Ice._require,
//  typeof(global) !== "undefined" && typeof(global.process) !== "undefined" ? exports : this));
/* slice2js browser-bundle-skip-end */



//////////////////
// WEBPACK FOOTER
// ./~/ice/src/Ice/Current.js
// module id = 138
// module chunks = 0